import { Component } from "@angular/core";
import { ConfigPanelTab } from "src/app/shared/components/configPanelTab/config-panel.component";

@Component({
  selector: "app-configuracion-servicios",
  templateUrl: "./config-servicios.component.html",
  styleUrls: ["./config-servicios.css"],
})
export class ConfiguracionServiciosComponent {
  activeTab = "servicio";

  tabs: ConfigPanelTab[] = [
    {
      id: "servicio",
      label: "Servicio externo",
      icon: "fa-solid fa-cloud",
    },
    {
      id: "credenciales",
      label: "Credenciales",
      icon: "fa-solid fa-key",
    },
    {
      id: "bucket",
      label: "Sistemas de archivos",
      icon: "fa-solid fa-database",
    },
    {
      id: "flujos",
      label: "Flujos",
      icon: "fa-solid fa-cogs",
    },
  ];
}
